import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForJsmStorageOverLimit(context: EditionAwarenessContextType): boolean {
	const {
		storageUsageInGB,
		storageLimitInGB,
		storageIsUnlimited,
		product,
		edition,
		canUpgrade,
		canDirectBuyUpgrade,
		userRoles,
	} = context;

	if (!storageUsageInGB || !storageLimitInGB) {
		return false;
	}

	const userIsJiraAdmin = userRoles?.includes('JIRA_ADMIN') ?? false;

	return (
		product === 'jira-service-management' &&
		userIsJiraAdmin &&
		edition === 'free' &&
		!!(canUpgrade || canDirectBuyUpgrade) &&
		!storageIsUnlimited &&
		storageUsageInGB >= storageLimitInGB &&
		fg('jsmgrowth-267_-_enforce_storage_limits')
	);
}
